import { api, makeApiRequest } from './_init'

const crmApi = {
  fetchSupportedAsync: async () => {
    return await makeApiRequest(api, 'get', '/crm/supported')
  },
  exportNLQToCRMAsync: async ({ crm_name, secret_id, container_name, nlq_id, ids }) => {
    const params = new URLSearchParams()
    params.append('crm_name', crm_name)
    params.append('secret_id', secret_id)
    params.append('container_name', container_name)

    return await makeApiRequest(api, 'post', `/crm/export/nlq?${params.toString()}`, {
      nlq_id,
      ids,
    })
  },
  exportBackhaulPackageToCRMAsync: async ({ crm_name, secret_id, container_name, packageId, tc }) => {
    const params = new URLSearchParams()
    params.append('crm_name', crm_name)
    params.append('secret_id', secret_id)
    params.append('container_name', container_name)

    return await makeApiRequest(api, 'post', `/crm/export/package?${params.toString()}`, {
      package_id: Number(packageId),
      tc,
    })
  }
}

export default crmApi
